import React from 'react';
import PropTypes from 'prop-types';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import {
  FDDialogActions, FDDialogContent, FDDialogTitle, FDList, FDListItem, FDListItemText,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { getBorder } from 'Components/utils';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { stepMap } from '../..';


const useStyles = buildUseStyles('BackupCode', (theme) => ({
  secret: {
    textAlign: 'center',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.facet.lightGray,
    ...getBorder(theme, {
      all: true,
      color: theme.palette.facet.mediumGray,
    }),
    borderRadius: theme.radius.sm,
  },
}));


const BackupCode = ({ changeState }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const classes = useStyles();

  return (
    <>
      <FDDialogTitle value={'Open & Configure the App'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} spacing={2}>
          <FDList>
            <FDListItem>
              <FDListItemText primaryText={'1. Add a new site in your authenticator app.'} />
            </FDListItem>
            <FDListItem>
              <FDListItemText primaryText={'2. Enter this code to add Facet.'} />
            </FDListItem>
          </FDList>
          <div className={classes.secret} test={'security-settings-authenticatorApp-register-modal-secret'}>
            <MetaControlField attr={'secret'} />
          </div>
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          onClick={() => {
            logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Authenticator: Enter verification code');
            changeState(stepMap.enterVerificationCode);
          }}
          test={'security-settings-button-authenticatorApp-register-modal-continue'}
        />
      </FDDialogActions>
    </>
  );
};

BackupCode.propTypes = {
  changeState: PropTypes.func.isRequired,
};

export default BackupCode;
